var map = {
	"./0caca.png": 208,
	"./1caca.png": 209,
	"./2caca.png": 210,
	"./3caca.png": 211,
	"./asistio.png": 212,
	"./ausencia.png": 213,
	"./ausente.png": 214,
	"./despierto.png": 215,
	"./dormido.png": 216,
	"./edit.png": 217,
	"./fruta.png": 218,
	"./malcaca.png": 219,
	"./mitad.png": 220,
	"./nada.png": 221,
	"./no-caca.png": 222,
	"./nocome.png": 223,
	"./parcial.png": 224,
	"./pure-huevo.png": 225,
	"./pure-pavo.png": 226,
	"./pure-pescado.png": 227,
	"./pure-pollo.png": 228,
	"./pure-ternera.png": 229,
	"./pure.png": 230,
	"./todo.png": 231,
	"./xcaca.png": 232,
	"./yogur.png": 233
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 207;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons nonrecursive ^\.\/.*$
// module id = 207
// module chunks = 1